module.exports = __webpack_public_path__ + "img/check.fd82e61a.png";